import style from './ProgressBar.module.scss';
import cx from 'classnames';

type ProgressBarProps = {
  max?: number;
  currentTime: number;
  onSeek: (e: React.ChangeEvent<HTMLInputElement>) => void;
} & React.HTMLProps<HTMLInputElement>;

const ProgressBar = ({
  className,
  currentTime,
  max = 100,
  onSeek,
  ...rest
}: ProgressBarProps) => {
  return (
    <input
      type="range"
      className={cx(style.range, className)}
      value={currentTime}
      max={max}
      style={{
        backgroundSize: `${currentTime}% 100%`,
      }}
      onChange={onSeek}
      {...rest}
    />
  );
};

export default ProgressBar;
